import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate } from "react-router-dom";

export const BinBadge = ({ type = 'events' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
      navigate('/deleted-events');
  };

  return (
    <IconButton
      aria-label="View deleted items"
      onClick={handleClick}
      style={{ color: "#E74A21" }}
    >
      <Badge
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        badgeContent=""
        title={`View deleted ${type}`}
      >
        <DeleteOutlineIcon />
      </Badge>
    </IconButton>
  );
};